import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { QuestionData, QuestionModule, QuestionModuleData, PageModelData } from '@/domains/seek/types';
import { QuestionStatus } from '@/domains/seek/types';
import type { PageModel } from '../page-model';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import _ from 'lodash';

@injectable()
export class PageModelImpl extends AbstractModel<PageModelData> implements PageModel {
    _modelData: PageModelData = {
        seek_id: '',
        input: '',
        _is_init_finished: false,
        _create_loading: false,
        _init_loading: false,
        _page_status: QuestionStatus.starting,
        _question_list: [],
        _request_signal: '',
    }

    constructor(
    ) {
        super();
    }

    public updateModuleData(question_id: string, moduleName: QuestionModule, getLatestModuleValue: (value: QuestionModuleData) => QuestionModuleData) {
        const pageData = this.modelData;
        const questionData = _.find(pageData._question_list, { question_id });
        if (!questionData) throw new Error('question not found');
        let currentModule = _.find(questionData.module_data, { module_name: moduleName })
        if (!currentModule) return;
        currentModule = getLatestModuleValue(currentModule);
        this.update(() => pageData)
    }

    public updateQuestionData(question_id: string, getLatestQuestionValue: (value: QuestionData) => QuestionData) {
        const pageData = this.modelData;
        let questionData = _.find(pageData._question_list, { question_id });
        if (!questionData) throw new Error('question not found');
        questionData = getLatestQuestionValue(questionData);
        this.update(() => pageData)
    }

    public getQuestionData(question_id: string): QuestionData | undefined {
        const pageData = this.modelData;
        return _.find(pageData._question_list, { question_id });
    }

    public getModuleData(question_id: string, moduleName: QuestionModule): QuestionModuleData | undefined {
        const pageData = this.modelData;
        const questionData = _.find(pageData._question_list, { question_id });
        if (!questionData) return;
        return _.find(questionData.module_data, { module_name: moduleName });
    }
}
